// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fmV9","index":"styles_index__3u0nL"};